import {
    FETCH_DATA_UNIVERSITIES_REQUEST,
    FETCH_DATA_UNIVERSITIES_SUCCESS,
    FETCH_DATA_UNIVERSITIES_FAILURE,
} from '../../actions/universities/get-universities-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const UniversitiesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_UNIVERSITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_UNIVERSITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_UNIVERSITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default UniversitiesReducer;